export default __webpack_public_path__ + "static/media/customersupport.d6ecd1e1.svg";